// src/features/tools/ToolsModule.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ToolsList from './ToolsList';

function ToolsModule() {
  return (
    <Routes>
      {/* Ruta base: muestra la lista de equipos */}
      <Route index element={<ToolsList />} />
      
      {/* Aquí podríamos agregar más rutas si se necesitan vistas adicionales */}
    </Routes>
  );
}

export default ToolsModule;